var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStrategyStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#DDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5866 21.8139C33.0666 21.8139 32.6533 21.4005 32.6533 20.8805V19.1739C32.6533 17.8672 32.0933 16.6139 31.1333 15.7339C30.1466 14.8405 28.88 14.4272 27.5466 14.5472C25.3066 14.7605 23.3466 17.0405 23.3466 19.4139V20.6139C23.3466 21.1339 22.9333 21.5472 22.4133 21.5472C21.8933 21.5472 21.48 21.1339 21.48 20.6139V19.4139C21.48 16.0805 24.1733 13.0005 27.36 12.6939C29.2133 12.5205 31 13.1072 32.3733 14.3605C33.7333 15.5872 34.5066 17.3472 34.5066 19.1739V20.8805C34.5066 21.4005 34.0933 21.8139 33.5866 21.8139Z",
    fill: "#4683FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6134 24.9464C37.4934 23.7064 35.6534 23.1064 32.9601 23.1064H23.0401C20.3467 23.1064 18.5067 23.7064 17.3867 24.9464C16.0934 26.3864 16.1334 28.3064 16.2801 29.6398L17.2134 37.0664C17.4934 39.6664 18.5467 42.3331 24.2801 42.3331H31.7201C37.4534 42.3331 38.5067 39.6664 38.7867 37.0798L39.7201 29.6264C39.8667 28.3064 39.9067 26.3864 38.6134 24.9464ZM28.0001 37.7731C25.2134 37.7731 22.9467 35.5064 22.9467 32.7198C22.9467 29.9331 25.2134 27.6664 28.0001 27.6664C30.7867 27.6664 33.0534 29.9331 33.0534 32.7198C33.0534 35.5064 30.7867 37.7731 28.0001 37.7731Z",
    fill: "#064AD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40C31.866 40 35 36.866 35 33C35 29.134 31.866 26 28 26C24.134 26 21 29.134 21 33C21 36.866 24.134 40 28 40Z",
    fill: "#064AD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 35.98L26.13 32.89C26.47 32.45 27.1 32.37 27.54 32.71L29.37 34.15C29.81 34.49 30.44 34.41 30.78 33.98L33.09 31",
    stroke: "#DDE8FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.75,
    cy: 30,
    r: 1.5,
    fill: "#4683FC",
    stroke: "#DDE8FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 36,
    r: 1.5,
    fill: "#4683FC",
    stroke: "#DDE8FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 25.5,
    r: 1,
    fill: "#DDE8FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25.5,
    r: 1,
    fill: "#DDE8FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyStore);
export default __webpack_public_path__ + "static/media/StrategyStore.245850c0895994a115128a26375f6b8f.svg";
export { ForwardRef as ReactComponent };